import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { ListMenus } from "./ListMenus";
import { ErrorLoadingMenu } from "./ErrorLoadingMenu";
  
 export const Navigation = (props) => {
  const  { loading } = useSelector( (state) => state.navigation)
  
  useEffect(() => {
  },[loading]) 

  return (
    <nav className="mt-2">
      <ul
        className="nav nav-pills nav-sidebar flex-column"
        data-widget="treeview"
        role="menu"
        data-accordion="false">
        { loading 
          ? (<ListMenus />) 
          : (<ErrorLoadingMenu/>) 
        }         


      </ul>
    </nav>
  )
}